import { parseJSON } from "date-fns";
import { DateValuePair } from "@rentablo/api/apiv1";
import { InvestmentChartData } from "./mergeCloseByDate";

export const convertBalancesToChartData = (
  data?: DateValuePair[]
): InvestmentChartData[] => {
  if (!data) return [];
  return data.flatMap(({ date, value }) => {
    if (date === undefined || value === undefined) return [];
    return [
      {
        date: parseJSON(date),
        value: Math.round(value * 100) / 100,
      },
    ];
  });
};
